import { findMatchedAppearance } from './matching'
import type { AppearanceHistoryStore } from './AppearanceHistoryStore'
import type { BoardMeta, CoverageStatus, MessageAppearanceRow, ParentFanoutRecord, TimeRange } from './types'

export const assembleBatch = async ({
  parents,
  childBoards,
  childStores,
  targetRange,
  matchWindowMs
}: {
  parents: MessageAppearanceRow[]
  childBoards: BoardMeta[]
  childStores: Record<string, AppearanceHistoryStore>
  targetRange: TimeRange
  matchWindowMs: number
}): Promise<ParentFanoutRecord[]> => {
  await Promise.all(
    childBoards.map(async board => {
      const store = childStores[board.id]
      if (!store || store.isRangeCovered(targetRange)) return
      await store.ensureRange(targetRange)
    })
  )

  return parents.map(parent => {
    let hasUnknownCoverage = false
    const rows = childBoards.map(board => {
      const store = childStores[board.id]
      const parentWindow = { min: parent.created, max: parent.created + matchWindowMs }
      const coverageStatus: CoverageStatus = store?.isRangeCovered(parentWindow) ? 'complete' : 'unknown'
      if (coverageStatus === 'unknown') {
        hasUnknownCoverage = true
      }
      const appearances = store ? store.queryRange(parentWindow) : []
      const matchedAppearance = findMatchedAppearance(
        appearances,
        parent.created,
        parent.attribution,
        matchWindowMs
      )
      return {
        board,
        matchedAppearance,
        coverageStatus,
        noAppearanceReason: null
      }
    })

    return {
      parent,
      rows,
      matchStatus: hasUnknownCoverage ? 'pending' : 'ready',
      ackStatus: 'idle',
      acksByAppearanceId: new Map<string, number>()
    }
  })
}
